import React from 'react';
import withIcon from '../utilities/withIcon';

const IconFolderUser = () => {
  return (
    <g>
      <path d="M1.05 15a1.05 1.05 0 0 1-1.044-.936L0 13.95v-8.9c0-.104.015-.206.044-.301H0V2.051c0-.45.284-.84.76-1l.135-.037L1.05 1l4.743.016c.396.001.754.224.931.57l.052.12.84 2.301 7.335.01c.541 0 .986.41 1.043.935l.006.114v8.883c0 .541-.41.987-.936 1.044L14.95 15H1.05zm.45-9.499V13.5h2.81c.364-.965 1.103-2 2.518-2h2.844c1.415 0 2.154 1.035 2.519 2H14.5V5.516l-13-.015zm6.75.999c1.105 0 2 .824 2 1.84 0 1.018-.895 2.66-2 2.66s-2-1.642-2-2.66c0-1.016.895-1.84 2-1.84zM1.5 2.502l-.001 1.499 4.518.005-.543-1.491L1.5 2.502z" />
    </g>
  );
};

export default withIcon(IconFolderUser);
